<!-- src/views/Inventario/InventoryLayout.vue -->
<template>
  <AppNavbar/>
  <div class="d-flex flex-column inventory-layout">
    <AppHeader title="Catálogo e Inventario" class="header-compact px-4 border-bottom">
      <template #buttons>
        <button
          v-if="showBackButton"
          type="button"
          class="btn btn-outline-secondary inventory-back-button"
          @click="goBack"
        >
          <i class="bi bi-arrow-left"></i>
          Volver
        </button>
      </template>
    </AppHeader>

    <div class="inventory-body d-flex flex-grow-1">
      <main class="flex-fill p-4">
        <router-view/>
      </main>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/AppHeader.vue';
  import AppNavbar from '@/components/AppNavbar.vue';
  export default {
    name: 'InventoryLayout',
    components: {
      AppHeader,
      AppNavbar
    },
    computed: {
      showBackButton() {
        return this.$route?.name && this.$route.name !== 'InvDashboard';
      }
    },
    methods: {
      goBack() {
        if (window.history.length > 1) {
          this.$router.back();
          return;
        }
        this.$router.push({ name: 'InvDashboard' });
      }
    }
  }
</script>

<style scoped>

.inventory-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.inventory-layout .d-flex {
  flex-grow: 1;
}

.header-compact  {
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.header-compact h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.inventory-back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.inventory-body {
  position: relative;
  min-height: 0;
}

main {
  background: #f9f9f9;
  overflow-y: auto;
  min-width: 0;
}

@media (max-width: 991.98px) {
  .header-compact {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .header-compact h1 {
    font-size: 1.15rem;
  }

  main {
    padding: 1rem !important;
  }
}
</style>
